
import { Component, Vue } from "vue-property-decorator";
@Component
export default class App extends Vue {
  protected isStaging = process.env.VUE_APP_ENV !== "production";
}
